interface HttpErrorResponse extends Error {
	response?: {
		text?: string;
	};
}

interface HttpErrorResponseWithErrorCode {
	errorCode?: number;
}

enum InvalidCampaignPropertyKeywords {
	SUPPORTED_OPTIONS = 'SupportedOptions',
	GEOTARGETING = 'geo_targeted',
	TABLEAU_REPORTING = 'tableau_reporting',
	ADWORDS = 'adwords',
	BUDGET = 'budget should',
	BUDGET_TOTAL = 'budget_total should',
	REGION = 'region should',
	PARTNERSHIP_TYPE = 'PartnershipType',
	START_DATE = 'start_date should',
	END_DATE = 'end_date should',
	CURRENCY = 'currency should',
	CLIENT_SERVICES_PERSON = 'assistant_id should',
	ACCOUNT_MANAGER = 'handler_id should',
	CRM_ID = 'crm_id should'
}

enum InvalidCampaignPropertyCategories {
	UNSET = '',
	PARTNERSHIP_TYPE = 'partnership type',
	REGION = 'region',
	BUDGET = 'budget',
	BUDGET_MISMATCH = 'budget mismatch',
	ADWORDS_START = 'adwords start date',
	ADWORDS_END = 'adwords end date',
	GEOTARGETING = 'geotargeting',
	TABLEAU_REPORTING = 'tableau reporting',
	INTERNAL = 'internal',
	NO_GEO_BREAKDOWN = 'no-geographical-breakdown',
	INCLUDE_NON_PREMIUM_PROGRAMMES = 'include-non-premium-programmes',
	FIXED_END_DATE = 'fixed-end-date',
	START_DATE = 'start date',
	END_DATE = 'end date',
	CURRENCY = 'currency',
	CLIENT_SERVICES_PERSON = 'client services person',
	ACCOUNT_MANAGER = 'account manager',
	CRM_ID = 'CRM ID'
}

interface InvalidCampaignPropertyDetails {
	category: InvalidCampaignPropertyCategories;
	value: string;
}

interface IServiceErrorResult {
	errorCode: number;
	errorName: string;
	message: string;
	method: string;
	path: string;
	statusCode: number;
	timestamp: string;
}

interface IDuplicateEntryErrorResult extends IServiceErrorResult {
	cause: {
		id: number | undefined;
		name: string | undefined;
		startDate: string | undefined;
	}
}

export {
	HttpErrorResponse,
	HttpErrorResponseWithErrorCode,
	InvalidCampaignPropertyDetails,
	InvalidCampaignPropertyCategories,
	InvalidCampaignPropertyKeywords,
	IDuplicateEntryErrorResult
};
